// store.js
import { writable } from 'svelte/store';

export const current_path = writable("/")

export const currentUser = writable({
  name: "",
  phone: "",
  email: "",
  country: "",
  state: "",
  city: "",
  loggedIn: false,
})

export const formData =  writable({
  question: "",
  qiGuaPerson: "",
  askForWho: "",
  timestamp: "",
  date: "not yet set...",
  extra: "",
  comment: "",
})
